// extracted by mini-css-extract-plugin
export default {"modal":"xZYnz","title":"BknIH","text":"S98QZ","actions":"Tgzgk","confirmAction":"HOHkG"};